module.exports = __webpack_public_path__ + "img/IMG_6258_L_WoodMatted_MockedUp.276fc651.jpg";